export enum Browser {
  Opera = 'Opera',
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  MSIE = 'Internet Explorer',
  'rv:' = 'IE',
  Safari = 'Safari',
  OPR = 'Opr',
}
